import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=f85e41ac"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&id=f85e41ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports